"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/* Captured From PROD at http://localhost:3000/en/buy/configure */
var DEFAULT_PROPS = {
  id: 'language-masters_en_1550692635867',
  resourceType: 'CarSelector_2_0_0',
  lastModified: '1550692635867',
  selectedLabel: 'Selected',
  componentLabel: null,
  enableTwoColumns: false,
  ctaEnabled: true,
  ctaLabel: 'Enter Code',
  ctaRedirectLink: '#',
  zipCodeEnabled: true,
  zipCodeHeadingText: 'Enter your zip code then pick a car',
  zipCodeLabel: 'ZIP CODE',
  zipCodeErrorMsg: 'Please enter a valid zip code',
  zipCode: {
    validationRegEx: '^\\d{5}$'
  },
  customizedLabel: 'New 3D Customizer',
  modelYearEnabled: true,
  modelYearLabel: 'Model year preference (optional)',
  modelYear: [],
  productTile: [],
  __typename: 'CarSelector'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;